import io from "socket.io-client"
import store from "@/store"
import { serverURL } from "@/utils/http"

let socket = null

export const initSocket = () => {
    const token = store.state.auth.token
    // const tenant = store.state.auth.tenant

    // Build query params
    const query = {}
    if (token) query.token = token

    const subdomain = store.getters["auth/tenantSubdomain"]
    if (subdomain) {
        query.tenantSubdomain = subdomain
    }

    // Initialize
    socket = io(serverURL, {
        query,
        transports: ["websocket"],
        extraHeaders: {
            "X-Tenant-Subdomain": subdomain || ""
        }
    })

    socket.on("connect", () => {
        console.log("Socket connected")
    })

    socket.on("disconnect", () => {
        console.log("Socket disconnected")
    })

    return socket
}

export const getSocket = () => {
    if (!socket) {
        return initSocket()
    }
    return socket
}

export const emitTenantEvent = (eventName, ...args) => {
    const s = getSocket()
    // User requirement: "include tenantId in events (e.g., socket.emit('chat_message', msg, groupId, tenantId))"
    // We assume the caller handles the arguments, but we can verify tenant exists
    // OR we can append tenantId to the args if the last arg is missing?
    // It's safer to just let the component handle the arguments, but providing the socket instance is key.
    s.emit(eventName, ...args)
}

export const joinTenantRoom = (roomName) => {
    const s = getSocket()
    const tenantId = store.state.auth.user?.tenantId
    if (tenantId) {
        s.emit("join", { tenantId, room: roomName })
    }
}
